import React, { FC } from 'react';
import { Box, Breadcrumbs as MdBreadcrumbs, BreadcrumbsProps } from '@material-ui/core';
import { createUseStyles } from '../theming';

const useStyles = createUseStyles({
  root: {
    '& li > *': {
      fontSize: '0.875rem !important',
    },
  },
});

type Props = BreadcrumbsProps;

const Breadcrumbs: FC<Props> = (props) => {
  const classes = useStyles();

  return (
    <MdBreadcrumbs
      separator={<Box width='4px' height='4px' marginX='8px' borderRadius='50%' bgcolor='#919eab' />}
      className={classes.root}
      {...props}
    />
  );
};

export default Breadcrumbs;
